import React from "react";
import styles from "./Table.module.sass";
import cn from "classnames";
import Row from "./Row";
import { useUser } from "../../../context";
import ticket from "../../../i11/TicketingProvider";

const Table = ({ open, data, isLoading, page, setPage, total }) => {
	const { locale } = useUser();
	return (
		<div className={cn(styles.wrapper)}>
			<div className={cn(styles.table)}>
				<div className={styles.row}>
					<div className={styles.col} />
					<div className={styles.col}>{ticket[locale].text}</div>
					<div className={styles.col}>{ticket[locale].description}</div>
					<div className={styles.col} />
					<div className={styles.col} />
				</div>
				{[ticket[locale].help_desk].map((e) => {
					return <Row open={open} key={e._id} data={e} />;
				})}
			</div>
			{/* {data.length === 0 && !isLoading && <Empthy />} */}
			{/* {isLoading && <Loader className={styles.loader} />} */}
		</div>
	);
};

export default Table;
